/* toRoman */
angular.module('LeasePilot').filter('toRoman', function() {
  return function(num, upperCase) {
    upperCase = upperCase ? upperCase.toLowerCase() === 'true' : false;
    return toRoman(num, upperCase);
  };
});
